import React from 'react'
import { prefix } from '../normalizer'
import InputKeyValue from '../shared/InputKeyValue'

const tRegister = prefix('gamification2026.register')

const getProp = (field, property) => {
  if (field === undefined) return
  return field[property]
}

const ExtraForm = ({ onUserChange, errors, extraFields }) => {
  const extraFieldsPairs = extraFields.flatMap((_, i, a) => i % 2 ? [] : [a.slice(i, i + 2)])

  return (
    <div className="register__section">
      <h3 className="register__section-title">{tRegister('extra-info')}</h3>
      {extraFieldsPairs.map((pair, pairIndex) => (
        <div key={pairIndex} className="register__row">
          {pair.map((field, fieldIndex) => (
            <InputKeyValue
              key={fieldIndex}
              title={getProp(field, 'field_label')}
              placeholder={getProp(field, 'field_label')}
              name={getProp(field, 'field_name')}
              type="text"
              required={getProp(field, 'required')}
              onChange={onUserChange}
              hint={getProp(field, 'field_hint') ? [getProp(field, 'field_hint')] : undefined}
              error={errors && errors[getProp(field, 'field_name')]}
            />
          ))}
        </div>
      ))}
    </div>
  )
}

export default ExtraForm
